import { ref, nextTick, watch, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0061e0f2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, "请上传谷歌《earning report》收入报告", -1));
const _hoisted_3 = ["onMouseover"];
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  class: "ios-account-item-inner"
};
const _hoisted_6 = {
  class: "ios-account-info"
};
const _hoisted_7 = {
  class: "ios-account-name"
};
const _hoisted_8 = {
  key: 0,
  class: "ios-uploaded-tag"
};
const _hoisted_9 = {
  class: "ios-rate-tips"
};
const _hoisted_10 = {
  class: "ios-tips-text"
};
const _hoisted_11 = ["onMouseover"];
const _hoisted_12 = {
  class: "rate-tip"
};
const _hoisted_13 = {
  class: "rate-tip-hd"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "rate-tip-ul"
}, [/*#__PURE__*/_createElementVNode("li", {
  class: "rate-tip-li"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "rate-tip-dot",
  "aria-hidden": "true"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "rate-tip-bd"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "rate-tip-main"
}, "匹配成功（使用完整账号简称命名）："), /*#__PURE__*/_createElementVNode("div", {
  class: "rate-tip-sub"
}, "自动计算「余额」「预扣税」「调整」「收入」字段。")])]), /*#__PURE__*/_createElementVNode("li", {
  class: "rate-tip-li muted"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "rate-tip-dot",
  "aria-hidden": "true"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "rate-tip-bd"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "rate-tip-main"
}, "未匹配（其他命名）："), /*#__PURE__*/_createElementVNode("div", {
  class: "rate-tip-sub"
}, "仅计算账号对应「收入」字段。")])])], -1));
const _hoisted_15 = {
  class: "mybtnsModel"
};
import { postCvsUpload } from '@/api/thirdParty';
import { OK } from '@/common';
import { message } from 'ant-design-vue';
import { useStore } from '@/store';
import { addTask, getCurrencyAccountList, getCurrentIosAccountList, getAllRateList } from '@/api/billApi';
import dayjs from 'dayjs';
import { CheckOutlined } from '@ant-design/icons-vue';
import { DynamicMultipleVirtualScrollSelect } from '@dbt/product-select';
import { CheckCircleOutlined, WarningOutlined, InfoCircleOutlined, FileTextOutlined } from '@ant-design/icons-vue';
import '@dbt/product-select/dist/style.css';
export default /*#__PURE__*/_defineComponent({
  __name: 'IOSBillModal',
  props: {
    modelVisible: {
      default: false,
      type: Boolean
    },
    allAccountList: {
      type: Object,
      default: () => ({
        accountId: 0,
        accountName: ''
      })
    }
  },
  emits: ['update:modelVisible'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const currencyList = ref([]);
    // 响应式数据
    const formRef = ref();
    const formState = ref({
      taskType: 10,
      accountId: [],
      currency: undefined,
      timeDate: undefined
    });
    const fileList = ref([]);
    const isLoading = ref(0);
    const delIndex = ref(-1);
    const accountOptions = ref([]);
    const accountSelectRef = ref(null);
    /** 下拉搜索字段（与 displayOptions 中的 label / accountName 对应） */
    const accountSearchFields = ['label', 'accountName'];
    /** 多选数组：内置 required 对 [] 可能判定不一致，用 type + min 更稳 */
    const accountIdRules = [{
      type: 'array',
      min: 1,
      required: true,
      message: '请选择账号'
    }];
    /** wrapper mousedown（capture 阶段）：popup 不可见时说明下拉将要打开，提前清空搜索词 */
    const onAccountSelectMousedown = () => {
      const popup = document.querySelector('.ios-bill-account-select-popup');
      const isOpen = !!popup && popup.getBoundingClientRect().height > 0;
      if (!isOpen) {
        var _accountSelectRef$val;
        (_accountSelectRef$val = accountSelectRef.value) === null || _accountSelectRef$val === void 0 || _accountSelectRef$val.closeDropdown();
      }
    };
    /** 第三方下拉未接入 FormItem 的 inject 时，需手动触发校验以清除错误态 */
    const onAccountIdFieldChange = () => {
      nextTick(() => {
        var _formRef$value;
        (_formRef$value = formRef.value) === null || _formRef$value === void 0 || _formRef$value.validateFields(['accountId']).catch(() => {});
      });
    };
    const rateTips = ref('');
    const rateType = ref('');
    const tipsLoading = ref(false);
    const isFileEncrypted = (file, callback) => {
      const reader = new FileReader();
      reader.onload = e => {
        var _e$target;
        const bytes = new Uint8Array((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.result);
        // 检查前10个字节是否都是可打印字符
        // ASCII 可打印字符范围：32-126，加上常见的控制字符：9(tab),10(换行),13(回车)
        const isPrintable = bytes.every(byte => byte >= 32 && byte <= 126 ||
        // 可打印字符
        byte === 9 || byte === 10 || byte === 13 ||
        // 制表符、换行符、回车符
        byte === 0xef || byte === 0xbb || byte === 0xbf);
        callback(!isPrintable);
      };
      reader.onerror = () => {
        callback(false);
      };
      // 读取前10个字节
      reader.readAsArrayBuffer(file.slice(0, 10));
    };
    const isCsvFile = file => {
      return file.name.includes('.csv');
    };
    const uploadCSV = async (fileInfo, callback) => {
      var _JSON$parse;
      const formData = new FormData();
      formData.append('accessAttribute', '1');
      formData.append('businessId', (_JSON$parse = JSON.parse(useStore().userInfo)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.id);
      formData.append('businessType', 'THIRD_BILL_GP');
      formData.append('file', fileInfo.file);
      isLoading.value++;
      try {
        const {
          code,
          data,
          msg
        } = await postCvsUpload(formData);
        if (code === OK) {
          callback(data);
          message.success(msg);
        }
      } catch (e) {}
      isLoading.value--;
    };
    // 文件上传处理
    const customRequestGP = fileInfo => {
      if (!isCsvFile(fileInfo.file)) {
        return message.error('请上传csv格式文件');
      }
      isFileEncrypted(fileInfo.file, async isEncrypted => {
        if (isEncrypted) {
          return message.error('文件已加密，请解密后上传');
        } else {
          uploadCSV(fileInfo, data => {
            fileList.value.push(data);
          });
        }
      });
    };
    const customRequestIOS = fileInfo => {
      if (!isCsvFile(fileInfo.file)) {
        return message.error('请上传csv格式文件');
      }
      isFileEncrypted(fileInfo.file, async isEncrypted => {
        if (isEncrypted) {
          return message.error('文件已加密，请解密后上传');
        } else {
          uploadCSV(fileInfo, data => {
            fileList.value.push(data);
          });
        }
      });
    };
    const syncAccountDisplayOptions = () => {
      const list = accountOptions.value || [];
      const apply = () => {
        if (!accountSelectRef.value) return;
        accountSelectRef.value.displayOptions = list.map(item => ({
          ...item,
          label: item.accountName,
          value: item.accountId != null ? String(item.accountId) : '',
          height: 32
        }));
      };
      if (accountSelectRef.value) {
        apply();
      } else {
        nextTick(() => apply());
      }
    };
    const isAccountOptionSelected = item => {
      const v = item.value != null ? String(item.value) : '';
      return formState.value.accountId.includes(v);
    };
    const closeModal = () => {
      emit('update:modelVisible', false);
      rateTips.value = '';
      rateType.value = '';
      formRef.value.resetFields();
      fileList.value = [];
    };
    // 文件列表操作
    const deleteFile = index => {
      fileList.value.splice(index, 1);
    };
    const showIcon = index => {
      delIndex.value = index;
    };
    const hideIcon = () => {
      delIndex.value = -1;
    };
    // 提交相关方法
    const postOnSubmit = async param => {
      try {
        const {
          code,
          msg
        } = await addTask(param);
        if (code === OK) {
          message.success(msg);
          closeModal();
        }
      } catch (e) {}
    };
    const onSubmitIos = () => {
      if (!formState.value.accountId.length) {
        return message.info('请选择发布账号');
      }
      const accountList = Array.isArray(props.allAccountList) ? props.allAccountList : [];
      const billMonthStr = dayjs(formState.value.timeDate).format('YYYY-MM');
      const param = {
        list: formState.value.accountId.map(rawId => {
          var _row$currency, _row$accountName;
          const accountId = Number(rawId);
          const row = accountList.find(a => a.accountId === accountId);
          return {
            reqParams: {
              currency: (_row$currency = row === null || row === void 0 ? void 0 : row.currency) !== null && _row$currency !== void 0 ? _row$currency : '',
              fileUrlList: fileList.value.length === 0 ? [] : fileList.value.map(f => f.fileUrl),
              accountId,
              billMonth: billMonthStr
            },
            taskType: formState.value.taskType,
            taskName: fileList.value.length === 0 ? `${billMonthStr}(${(_row$accountName = row === null || row === void 0 ? void 0 : row.accountName) !== null && _row$accountName !== void 0 ? _row$accountName : accountId})` : fileList.value[0].originalFilename
          };
        })
      };
      postOnSubmit(param);
    };
    const onSubmitGP = () => {
      const param = {
        list: fileList.value.map(item => ({
          reqParams: {
            fileUrl: item.fileUrl
          },
          taskType: formState.value.taskType,
          taskName: item.originalFilename
        }))
      };
      postOnSubmit(param);
    };
    const onSubmit = async () => {
      if (isLoading.value) {
        return message.info('文件上传中，请稍后提交');
      }
      formRef.value.validateFields().then(() => {
        // if (!fileList.value.length) {
        //   return message.info("请上传文件");
        // }
        if (formState.value.taskType == 0) {
          onSubmitGP();
        }
        if (formState.value.taskType == 10) {
          onSubmitIos();
        }
      }).catch(err => {});
    };
    const currencyChange = async () => {
      try {
        const {
          code,
          data
        } = await getCurrencyAccountList({
          accountType: 2,
          billMonth: formState.value.timeDate
        });
        if (code === OK) {
          currencyList.value = data === null || data === void 0 ? void 0 : data.list;
        }
      } catch (e) {}
    };
    const getIosAccount = async () => {
      const {
        code,
        data
      } = await getCurrentIosAccountList({
        accountType: 2,
        billMonth: dayjs(formState.value.timeDate).format('YYYY-MM')
      });
      if (code === OK) {
        var _formRef$value2;
        accountOptions.value = data === null || data === void 0 ? void 0 : data.list.map(item => {
          return item.accountList;
        }).flat();
        await nextTick();
        syncAccountDisplayOptions();
        formState.value.accountId = accountOptions.value.filter(account => !account.hasUploaded).map(item => String(item.accountId));
        (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 || _formRef$value2.validateFields(['accountId']);
      }
    };
    const handleTimeDateChange = async () => {
      formState.value.accountId = [];
      await nextTick();
      if (!formState.value.timeDate) return;
      await getIosAccount();
      queryAllRateList();
      // nextTick(() => {
      //   if (formState.value.timeDate) {
      //     await getIosAccount()
      //     queryAllRateList()
      //   }
      // })
      // const list = props.allAccountList
      // if (!Array.isArray(list) || list.length === 0) return
      // formState.value.accountId = list.map((item: { accountId: number }) => item.accountId)
    };
    // ios点击查询最全汇率账号
    const queryAllRateList = () => {
      formRef.value.validateFields().then(async () => {
        if (formState.value.taskType == 10) {
          tipsLoading.value = true;
          const res = await getAllRateList({
            billMonth: dayjs(formState.value.timeDate).format('YYYY-MM')
          });
          const {
            code,
            data
          } = res;
          if (code === '0' && !data.covered) {
            const list = props.allAccountList || [];
            const ids = data.missingExchangeAccountIds || [];
            const names = list.filter(item => item && ids.includes(item.accountId)) // 过滤出匹配的项
            .map(item => item.accountName) // 提取名字
            .join('、');
            rateType.value = 'warning';
            rateTips.value = `请上传： ${names} 汇率表`;
          } else {
            rateType.value = data.hint === '本月汇率表已上传' ? 'success' : 'error';
            rateTips.value = data.hint || '本月汇率表已上传';
          }
          tipsLoading.value = false;
        }
      }).catch(err => {
        tipsLoading.value = false;
      });
    };
    // 监听币种变化，自动选择所有账号
    watch(() => formState.value.currency, newVal => {
      if (newVal) {
        // nextTick(() => {
        //   console.log(accountOptions.value, newVal, "accountOptions.value,newVal");
        // })
        // const currentCurrency = accountOptions.value.find((item: any) => item.currency === newVal);
        // if (currentCurrency?.accountList) {
        //   formState.value.accountId = currentCurrency.accountList.filter(
        //     (account: any) => !account.hasUploaded
        //   );
        // }
      } else {
        formState.value.accountId = [];
      }
    });
    // 生命周期钩子
    onMounted(() => {
      currencyChange();
    });
    return (_ctx, _cache) => {
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        title: "生成账单",
        onCancel: closeModal,
        open: __props.modelVisible,
        width: "550px",
        centered: "",
        footer: false,
        maskClosable: false
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formState.value,
          labelAlign: "right",
          class: "form"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "月份",
            required: "",
            name: "timeDate"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_date_picker, {
              value: formState.value.timeDate,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => formState.value.timeDate = $event),
              picker: "month",
              format: "YYYY-MM",
              placeholder: "请选择月份",
              style: {
                "width": "366px"
              },
              onChange: handleTimeDateChange
            }, null, 8, ["value"])]),
            _: 1
          }), formState.value.taskType == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form_item, {
            label: "文件"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_upload, {
              multiple: true,
              "show-upload-list": false,
              customRequest: customRequestGP
            }, {
              default: _withCtx(() => [_createVNode(_component_a_button, {
                class: "borderBlue"
              }, {
                default: _withCtx(() => [_createVNode(_component_svg_icon, {
                  "icon-class": "upload_stencil",
                  "class-name": "mark-icon"
                }), _createTextVNode(" 点击上传 ")]),
                _: 1
              })]),
              _: 1
            }), _hoisted_2, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                class: "file-list",
                key: item.originalFilename,
                onMouseover: $event => showIcon(index),
                onMouseout: _cache[1] || (_cache[1] = $event => hideIcon())
              }, [_createVNode(_component_svg_icon, {
                "icon-class": "file",
                class: "file"
              }), _createElementVNode("div", null, _toDisplayString(item.originalFilename), 1), _withDirectives(_createVNode(_component_svg_icon, {
                "icon-class": "success_2",
                class: "delete"
              }, null, 512), [[_vShow, index !== delIndex.value]]), _withDirectives(_createVNode(_component_svg_icon, {
                "icon-class": "cha",
                class: "delete",
                onClick: $event => deleteFile(index)
              }, null, 8, ["onClick"]), [[_vShow, index === delIndex.value]])], 40, _hoisted_3);
            }), 128))]),
            _: 1
          })])) : _createCommentVNode("", true), formState.value.taskType == 10 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_a_form_item, {
            class: "modal-account-select",
            label: "账号",
            name: "accountId",
            rules: accountIdRules
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              onMousedownCapture: onAccountSelectMousedown
            }, [_createVNode(_unref(DynamicMultipleVirtualScrollSelect), {
              ref_key: "accountSelectRef",
              ref: accountSelectRef,
              modelValue: formState.value.accountId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formState.value.accountId = $event),
              "popup-class-name": "ios-bill-account-select-popup",
              placeholder: "请选择",
              "label-field": "label",
              "value-field": "value",
              width: "366px",
              "allow-clear": true,
              "show-arrow": "",
              "show-select-all": true,
              "show-detail": false,
              "max-tag-count": 1,
              "search-fields": accountSearchFields,
              "dropdown-max-height": 320,
              "item-height": 32,
              "remote-search": false,
              onChange: onAccountIdFieldChange
            }, {
              "product-item": _withCtx(({
                item
              }) => [_createElementVNode("div", {
                class: _normalizeClass(["ios-account-item-wrapper", {
                  'ios-account-item--uploaded': item.hasUploaded
                }]),
                style: _normalizeStyle({
                  height: (item.height || 32) + 'px'
                })
              }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(item.accountName), 1), item.hasUploaded ? (_openBlock(), _createElementBlock("span", _hoisted_8, "已上传")) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_unref(CheckOutlined), {
                class: "ios-check-icon"
              }, null, 512), [[_vShow, isAccountOptionSelected(item)]])])], 6)]),
              _: 1
            }, 8, ["modelValue"])], 32)]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "导入汇率表"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_a_upload, {
              multiple: true,
              "show-upload-list": false,
              customRequest: customRequestIOS
            }, {
              default: _withCtx(() => [_createVNode(_component_a_button, {
                class: "borderBlue"
              }, {
                default: _withCtx(() => [_createVNode(_component_svg_icon, {
                  "icon-class": "upload_stencil",
                  "class-name": "mark-icon"
                }), _createTextVNode(" 点击上传 ")]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_spin, {
              wrapperClassName: "ios-text",
              spinning: tipsLoading.value
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: _normalizeClass(['ios-tips-box', rateType.value])
              }, [_createElementVNode("div", null, [rateType.value === 'success' ? (_openBlock(), _createBlock(_unref(CheckCircleOutlined), {
                key: 0
              })) : _createCommentVNode("", true), rateType.value === 'warning' ? (_openBlock(), _createBlock(_unref(WarningOutlined), {
                key: 1
              })) : _createCommentVNode("", true), rateType.value === 'error' ? (_openBlock(), _createBlock(_unref(InfoCircleOutlined), {
                key: 2
              })) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_10, _toDisplayString(rateTips.value), 1)], 2)]),
              _: 1
            }, 8, ["spinning"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                class: "file-list",
                key: item.originalFilename,
                onMouseover: $event => showIcon(index),
                onMouseout: _cache[3] || (_cache[3] = $event => hideIcon())
              }, [_createVNode(_component_svg_icon, {
                "icon-class": "file",
                class: "file"
              }), _createElementVNode("div", null, _toDisplayString(item.originalFilename), 1), _withDirectives(_createVNode(_component_svg_icon, {
                "icon-class": "success_2",
                class: "delete"
              }, null, 512), [[_vShow, index !== delIndex.value]]), _withDirectives(_createVNode(_component_svg_icon, {
                "icon-class": "cha",
                class: "delete",
                onClick: $event => deleteFile(index)
              }, null, 8, ["onClick"]), [[_vShow, index === delIndex.value]])], 40, _hoisted_11);
            }), 128)), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_unref(FileTextOutlined), {
              class: "rate-tip-ico"
            }), _createTextVNode(" 汇率表命名规则与计算范围 ")]), _hoisted_14])]),
            _: 1
          })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_createVNode(_component_a_button, {
            style: {
              "margin-right": "8px"
            },
            class: "myGray",
            onClick: closeModal
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), _createVNode(_component_a_button, {
            type: "primary",
            loading: Boolean(isLoading.value),
            onClick: onSubmit
          }, {
            default: _withCtx(() => [_createTextVNode("提交")]),
            _: 1
          }, 8, ["loading"])])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});